import React, { useEffect, useRef } from 'react';
import styles from './LicenseContent.module.css';
import backIcon from "../icons/back_icn.png";

const LicenseContent = ({ onBack }) => {
  const contentRef = useRef(null);

  useEffect(() => {
    const content = contentRef.current;

    if (content) {
      let scrollStep = 1;
      let scrollInterval;

      const startAutoScroll = () => {
        scrollInterval = setInterval(() => {
          if (content.scrollTop + content.clientHeight >= content.scrollHeight) {
            clearInterval(scrollInterval);
          } else {
            content.scrollTop += scrollStep;
          }
        }, 50);
      };

      startAutoScroll();

      const stopAutoScroll = () => {
        clearInterval(scrollInterval);
        content.removeEventListener('wheel', stopAutoScroll);
        content.removeEventListener('touchstart', stopAutoScroll);
      };

      content.addEventListener('wheel', stopAutoScroll);
      content.addEventListener('touchstart', stopAutoScroll);

      return () => {
        content.removeEventListener('wheel', stopAutoScroll);
        content.removeEventListener('touchstart', stopAutoScroll);
        clearInterval(scrollInterval);
      };
    }
  }, []);

  return (
    <div className={styles.licenseContentContainer}>
      <div className={styles.licenseContent} ref={contentRef}>
       <h1>License Agreement</h1>
<p><strong>Effective Date:</strong> May 21, 2025</p>

<h2>Introduction</h2>
<p>
  This License Agreement ("Agreement") is made by and between Quality Performance Core (represented by Oleksandr Trishkin) ("Licensor") and you ("Licensee"). By accessing or using the provided Beat, you acknowledge that you are receiving a digital, intangible service granting you non-exclusive usage rights. This Agreement does not represent a sale of goods or a royalty-based transaction, but the provision of a digital service.
</p>

<h2>Service Fee</h2>
<p>
  Licensee shall pay the Service Fee to Licensor on the Effective Date. All rights granted are conditional upon timely payment; this Agreement is not valid until full payment is received.
</p>

<h2>Delivery of the Beat</h2>
<p>
  As part of our digital service, the Beat will be delivered according to the license type you purchased: for a <strong>KIT</strong> license, you receive a downloadable archive of individual track stems; for a <strong>WAV</strong> license, you receive a single high-quality WAV file of the fully mixed Beat. Delivery is made via a secure download link immediately after payment.
</p>

<h2>Term</h2>
<p>
  The Term of this Agreement shall be ten (10) years, expiring on the ten (10) year anniversary of the Effective Date.
</p>

<h2>License Grant</h2>
<p>
  Licensor grants Licensee a limited non-exclusive, non-transferable license to use the Beat in the preparation of one (1) new song or instrumental piece. Licensee may modify arrangement, length, tempo, or pitch for public release, but must disable Content ID systems on platforms such as YouTube, Instagram, Facebook, TikTok, and Snapchat.
</p>

<h2>Restrictions</h2>
<p>
  You may not resell, redistribute, sublicense, or claim ownership of the Beat in its original form. Unauthorized use outside the scope of this license is strictly prohibited.
</p>

<h2>Ownership</h2>
<p>
  All rights, title, and interest in the Beat remain the sole property of Licensor. Licensee may not register the Beat or New Song with any copyright office.
</p>

<h2>Mechanical License</h2>
<p>
  Producer grants Licensee a mechanical license for any controlled composition embodied in the New Song. Mechanical-related fees at 100% of the statutory rate are internal to this service and do not constitute a separate sale or royalty transaction.
</p>

<h2>Credit</h2>
<p>
  Licensee shall credit Producer as “Produced by Quality Performance Core” on all distributed copies of the New Song.
</p>

<h2>Producer’s Option</h2>
<p>
  Producer may terminate this license within three (3) years of the Effective Date by returning 200% of the Service Fee. Upon such termination, Licensee must remove the New Song from all distribution channels and cease public access.
</p>

<h2>Breach by Licensee</h2>
<p>
  Licensee has five (5) business days to cure any breach after written notice. Unauthorized exploitation outside these Terms makes Licensee liable for all proceeds and damages, and entitles Producer to injunctive relief and recovery of costs.
</p>

<h2>Warranties and Indemnification</h2>
<p>
  Producer provides the Beat “as is” without any warranties. Both parties warrant authority to enter this Agreement. Licensee agrees to indemnify and hold Producer harmless from third-party claims arising from Licensee’s use, and Producer likewise indemnifies Licensee against claims arising from Producer’s breach of warranties.
</p>

<h2>Miscellaneous</h2>
<p>
  This Agreement constitutes the entire understanding between the parties and may only be modified by a written instrument signed by both parties. If any provision is held invalid, the remainder remains effective. This Agreement is governed by and interpreted in accordance with the laws of Ukraine, and any disputes shall be resolved in the courts of Ukraine. Notices must be in writing. A digital copy available in “Your Files” is deemed an original. For the avoidance of doubt, this Agreement represents a digital service, not a sale of goods or a traditional royalty transaction.
</p>

<h2>Contact Us</h2>
<p>
  For questions regarding this Agreement, please contact us at contact@qpcore.com.
</p>
      </div>
      <img
        src={backIcon}
        alt="Back"
        className={`${styles.backIcon} ${styles.visible}`}
        onClick={onBack}
      />
    </div>
  );
};

export default LicenseContent;

